import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Milestone } from "lucide-react";
import api from "../lib/api";

/* Data-driven "towns & villages near here" — GeoNames coordinates + haversine.
   Hidden entirely when the place has no coordinates in the global index. */
export default function NearbyPlaces({ slug, accent = "#1a73e8", data: dataProp }) {
  const [fetched, setFetched] = useState(null);
  const data = dataProp !== undefined ? dataProp : fetched;

  useEffect(() => {
    if (dataProp !== undefined) return;
    setFetched(null);
    if (!slug) return;
    api.get("/geo/nearby", { params: { slug, limit: 12 } })
      .then((r) => setFetched(r.data)).catch(() => setFetched({ count: 0, items: [] }));
  }, [slug, dataProp]);

  if (!data || data.count === 0) return null;

  return (
    <section className="mb-8" data-testid="nearby-places">
      <h2 className="font-heading font-900 text-2xl border-b-2 pb-2 mb-3" style={{ borderColor: accent }}>
        Towns &amp; Villages Near {data.center?.name}
      </h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {data.items.map((p) => (
          <Link key={p.slug} to={`/explore/${p.slug}`} data-testid={`nearby-place-${p.slug.split("/").pop()}`}
            className="flex items-center gap-2.5 bg-white border border-zinc-200 px-3 py-2.5 hover:border-zinc-500 transition-colors">
            <MapPin className="w-4 h-4 shrink-0" style={{ color: accent }} />
            <span className="min-w-0">
              <span className="block text-sm font-700 truncate">{p.name}</span>
              <span className="block text-xs text-muted-foreground truncate">
                {p.state && p.state !== p.name ? `${p.state} · ` : ""}
                <Milestone className="w-3 h-3 inline -mt-0.5" /> {p.distance_km} km
                {p.population ? ` · pop ${p.population.toLocaleString()}` : ""}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
